// src/mixins/globalNavigation.js
export default {
    methods: {
      $goToProduct(item) {
        this.$router.push({
          name: 'ProductDetails',
          params: { code: item.code, slug: item.slug }
        })
      }
    }
  }
  